import type { ComponentType, SVGProps } from "react";

type IconProps = { className?: string } & Omit<
  SVGProps<SVGSVGElement>,
  "className"
>;

const base = (className: string) => ({
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  className,
  "aria-hidden": true,
});

/** Simple line icons for the funnel intake options, by the key the backend sends. Original artwork. */

const LowLibidoIcon = ({ className = "size-6" }: IconProps) => (
  <svg {...base(className)}>
    <circle cx="9" cy="14" r="4" />
    <path d="M15 9l5-5m0 0h-4m4 0v4" />
    <path d="M12 11.2 14 9" />
  </svg>
);

const HairLossIcon = ({ className = "size-6" }: IconProps) => (
  <svg {...base(className)}>
    <path d="M5 11a7 7 0 0 1 14 0" />
    <path d="M8 11c0 3 1 6 4 6s4-3 4-6" />
    <path d="M10 20l1-3m3 3-1-3" />
  </svg>
);

const SkinIcon = ({ className = "size-6" }: IconProps) => (
  <svg {...base(className)}>
    <path d="M7 4c2 2 2 4 5 4s3-2 5-4" />
    <path d="M6 21c0-4 2-7 6-7s6 3 6 7" />
    <path d="M10 11h.01M14 12h.01M12 16h.01" />
  </svg>
);

const CognitionIcon = ({ className = "size-6" }: IconProps) => (
  <svg {...base(className)}>
    <path d="M15 5a3 3 0 0 0-6 0 3 3 0 0 0-3 3 3 3 0 0 0 0 6 3 3 0 0 0 3 3 3 3 0 0 0 6 0 3 3 0 0 0 3-3 3 3 0 0 0 0-6 3 3 0 0 0-3-3Z" />
    <path d="M12 5v14" />
  </svg>
);

const NoneIcon = ({ className = "size-6" }: IconProps) => (
  <svg {...base(className)}>
    <circle cx="12" cy="12" r="9" />
    <path d="m9 9 6 6m0-6-6 6" />
  </svg>
);

const ScaleIcon = ({ className = "size-6" }: IconProps) => (
  <svg {...base(className)}>
    <rect x="4" y="4" width="16" height="16" rx="3" />
    <path d="M9 8a3 3 0 0 1 6 0" />
    <path d="M12 12v-2" />
  </svg>
);

const MuscleIcon = ({ className = "size-6" }: IconProps) => (
  <svg {...base(className)}>
    <path d="M4 13c2-1 3-3 5-3s3 2 6 2c2 0 4-1 4 2s-2 5-6 5H8a4 4 0 0 1-4-4Z" />
    <path d="M9 10V5a2 2 0 0 1 4 0v3" />
  </svg>
);

const MaintainIcon = ({ className = "size-6" }: IconProps) => (
  <svg {...base(className)}>
    <path d="M8 11V6a1.5 1.5 0 0 1 3 0v4" />
    <path d="M11 10V5.5a1.5 1.5 0 0 1 3 0V10" />
    <path d="M14 10.5V7a1.5 1.5 0 0 1 3 0v7a5 5 0 0 1-5 5H9.5a4 4 0 0 1-3-1.4L4 15" />
  </svg>
);

export const FUNNEL_ICON: Record<
  string,
  ComponentType<{ className?: string }>
> = {
  low_libido: LowLibidoIcon,
  hair_loss: HairLossIcon,
  skin: SkinIcon,
  cognition: CognitionIcon,
  none: NoneIcon,
  scale: ScaleIcon,
  muscle: MuscleIcon,
  maintain: MaintainIcon,
};
